export default {
  enabled: 'Activado',
  disabled: 'Desactivado',
  autoRedirect: 'Redirigir Automáticamente',
  isHistory: 'Es un historial',
  titlePlaceholder: 'Ingrese el título',
  urlPlaceholder: 'Ingrese la url de redirección...',
  checklist: 'Cuestionario',
  status: 'Estado',
  sortBy: 'Ordenar por',
  sortByFormat: '{{field}} de forma {{type}}',
  configHistory: 'Configurar enlace como historial',
  moveUp: 'Mover hacia Arriba',
  moveDown: 'Mover hacia Abajo',
  duplicate: 'Duplicar',
  remove: 'Eliminar',
  filterSelection: 'Selección de filtros',
  sort: 'Ordenar',
  field: 'Campo',
  order: 'Orden',
  filters: 'Filtros',
  requiredChecklist: 'Cuestionario*',
  clearSelection: 'Limpar selección',
  confirm: 'Confirmar',
  addNewLink: 'Añadir nuevo enlace',
  save: 'Guardar',
  sortOptions: {
    ID: 'Id',
    YEARLY_ID: 'Código',
    SCHEDULING: 'Fecha de programación',
    END_DATE: 'Fecha de finalización de la actividad',
    START_DATE: 'Fecha de inicio de la actividad'
  },
  orderOptions: {
    ASC: 'Ascendente',
    DESC: 'Descendente'
  },
  validation: {
    fillAllNames: 'Por favor, complete todos los nombres',
    fillAllUrls: 'Por favor, complete todas las urls',
    fillChecklistForHistory: 'Por favor, complete el cuestionario para el historial',
    invalidUrls: 'Existen urls inválidas',
    multipleAutoRedirects: 'No se permite más de un redireccionamiento automático',
    confirmSaveWithoutCustomLink: '¿Está seguro de que desea guardar sin enlace personalizado?'
  },
  customizeLinks: 'Personalizar enlaces'
}
